import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'

import {
  makeLink,
  queryWithoutFilters,
  activeFiltersParams
} from '../../../../common/utils/urlHelper'
import CactusIcon from '../../../components/icons/cactus'

const SearchNoResults = ({ location }) => {
  const renderClearFiltersLink = () => {
    const link = (
      <Link
        to={makeLink(queryWithoutFilters(location))}
        className="fds-c-text-link -decoration-reversed"
      >
        clearing your filters
      </Link>
    )

    return <span>Try {link}.</span>
  }

  return (
    <div className="fds-c-box -background-light fds-u-mb2 fds-u-p2">
      <div className="search-no-results">
        <div>
          <CactusIcon width="100" height="150" />
        </div>
        <div>
          <h2 className="fds-c-text-heading -size-xs">
            You&apos;ve ventured too far out into the desert!{' '}
            {activeFiltersParams.length
              ? renderClearFiltersLink()
              : 'Time to head back'}
          </h2>
          <p className="fds-c-text-body">
            {activeFiltersParams(location).length
              ? "We couldn't find any results for your search within the filters you've set."
              : "We couldn't find any results for your search. Use more generic words or double check your spelling."}
          </p>
        </div>
      </div>
    </div>
  )
}

SearchNoResults.propTypes = {
  location: PropTypes.object
}

export default SearchNoResults



// WEBPACK FOOTER //
// ./client/pages/search/result/searchNoResults.js